import {
  ActivityLogEntityTypeEnum,
  ActivityLogEventTypeEnum,
} from 'src/slices/services/api'

export { ActivityLogEntityTypeEnum, ActivityLogEventTypeEnum }

/**
 * ActivityLogのエンティティ種別（UI表示用）
 * Note: APIの ActivityLogEntityTypeEnum とは値が異なる
 */
export const ActivityLogEntityType = {
  Tenant: 'tenant',
  Calculation: 'calculation',
  Member: 'member',
  SalesReport: 'sales_report',
} as const

export type ActivityLogEntityType =
  (typeof ActivityLogEntityType)[keyof typeof ActivityLogEntityType]

/**
 * ActivityLog を絞り込む日付範囲 (YYYY-MM-DD)
 */
export type ActivityLogDateRange = {
  start: string
  end: string
}

/**
 * ActivityLogPanel の日付範囲フィルタ (DatePicker への受け渡し用)
 */
export type ActivityLogDateRangeFilter = {
  range: ActivityLogDateRange
  minDate?: string
  maxDate?: string
  onChange: (range: ActivityLogDateRange) => void
}

/**
 * Event Type のラベルマッピング
 */
export const EVENT_TYPE_LABELS: Partial<
  Record<
    ActivityLogEntityTypeEnum,
    Partial<Record<ActivityLogEventTypeEnum, string>>
  >
> = {
  [ActivityLogEntityTypeEnum.Member]: {
    [ActivityLogEventTypeEnum.Created]: 'ユーザー追加',
    [ActivityLogEventTypeEnum.Updated]: 'ユーザー編集',
  },
  [ActivityLogEntityTypeEnum.Tenant]: {
    [ActivityLogEventTypeEnum.Created]: 'テナント新規追加',
    [ActivityLogEventTypeEnum.Updated]: 'テナント編集',
  },
}
